/**
 * 初始化带层级缩进的表格的数据
 * 
 * root         boolean      区分是否是第一层
 * data         Array        数据
 * level        number       层级
 * expand       boolean      展开/收起
 * init         boolean      是否初始化
 * arr          Array        数组
 */
var time = new Date().getTime();

function p2t(root, data, level, expand, init, arr) {
    var arr = arr || [];
    var level = level != undefined && level != null && ++level || 0;
 
    data.forEach(function (row) {
        !row.children && (row.children = []);
        row._level = level;
        row._key = row._key || '' + (time++);

        /**
         * 只有初始化时_expand才接受传入的赋值(避免展开时子元素也被展开)，
         * 否则等于自身
         */
        if(init){
            row._expand = expand; 
        }else{
            row._expand = row._expand || false;
        }

        //是第一级时展开或
        //根据父节点的_expand是否显示
        (expand || root) && arr.push(row);
        /**
         * 初始化时或子节点为展开时遍历所有数据并赋值
         */
        (row._expand || init) && row.children.length && p2t(false, row.children, level, row._expand, init, arr);
    }, this);

    return arr;
}

//将参数数据转化为显示参数层级表格的数据--老版
function paramToTable(data, level, expand) {
    return p2t(true, data, level, expand);
}
    
//初始化数据，使数据带上必要的参数--老版
function init(data, expand) {
    return p2t(true, data, null, expand == undefined ? true : expand, true);
}

//增加parentType
function addParent(arr, parent){
    arr.forEach(function(r){
        r._parent = parent || {};
        r.children && r.children.length && addParent(r.children, r);
    })
}

//移除_parent
function removeParent(arr){
    arr.forEach(function(r){
        delete r._parent;
        r.children && r.children.length && removeParent(r.children);
    })
}

//移除其它参数
function remove_others(arr){
    arr.forEach(function(r){
        delete r._expand;
        delete r._key;
        delete r._level;
        r.children && r.children.length && remove_others(r.children);
    })
}

//获取数据类型
function getTypeOf(v){
    const type = Object.prototype.toString.call(v);
    switch(type){
        case "[object Object]":
            return "Object"
            break;
        case "[object Array]":
            return "Array"
            break;
        case "[object Number]":
            return "Number"
            break;
        case "[object Boolean]":
            return "Boolean"
            break;
        default:
            return "String"
    }
}

export default {
    paramToTable,
    init,
    addParent,
    removeParent,
    remove_others,
    getTypeOf
}